export function ctrlShortkey() {
  const isMac = navigator.userAgent.indexOf('Mac') !== -1;
  return isMac ? 'meta' : 'ctrl';
}

export default ctrlShortkey;
